/**
 * Internal dependencies
 */
import {
    CLOUD_BACKUP_PLANS_RECEIVE,
    CLOUD_BACKUP_PLANS_REQUEST,
    CLOUD_BACKUP_PLANS_REQUEST_SUCCESS,
    CLOUD_BACKUP_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllCloudBackupPlans, requestingCloudBackupPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function}   [description]
 * @return {[type]}                  [description]
 */
export const requestCloudBackupPlans = () => (dispatch) => {
    dispatch({
        type: CLOUD_BACKUP_PLANS_REQUEST
    });

    return cscom.cloudBackupPlan().list()
        .then(cloudBackupPlans => {
            dispatch({ type: CLOUD_BACKUP_PLANS_REQUEST_SUCCESS });
            dispatch({ type: CLOUD_BACKUP_PLANS_RECEIVE, payload: { items: cloudBackupPlans } });
            return cloudBackupPlans;
        })
        .catch((error) => {
            dispatch({ type: CLOUD_BACKUP_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllCloudBackupPlans(getState());
	const requesting = requestingCloudBackupPlans(getState());

	if (plans.length === 0 && requesting === false) {
		return dispatch(requestCloudBackupPlans(...props))
	}

	return plans;
}